export default __webpack_public_path__ + "static/media/instagram-icon.39f7b5da.svg";